import React, { useMemo } from 'react';
import NinjaTable from 'components/tables/NinjaTable';
import { CountryFormatter } from 'modules/CRMModule/formatters';
import TrafficLevelColumn from 'modules/ReportModule/components/TrafficLevelColumn';
import AnonymousUserFormatter from 'modules/ReportModule/formatters/AnonymousUserFormatter';
import { useJourneyReport } from 'modules/ReportModule/context/useJourneyReport';
import Ninja from '@ninja';
import EventTypeIcons from 'components/icons/EventTypeIcons';

const TrafficReportingEvents = () => {
  const { filter } = useJourneyReport();

  const columns = [
    {
      key: 'time_diff',
      name: 'Time ',
      renderCell: ({ row }) => (
        <span className='grid text-xs'>
          <span className='text-sm font-medium'>{row?.time_diff ? row.time_diff : '-'}</span>
        </span>
      ),
    },
    {
      key: 'event_name',
      name: 'Event',
      resizable: true,
      minWidth: 120,
      renderCell: ({ row }) => (
        <EventTypeIcons
          event={row?.event_name}
          showIcon={true}
          showEventName={true}
          size={0.7}
          color={Ninja.colors.info}
        />
      ),
    },
    {
      key: 'user_id',
      name: 'User ID ',
      minWidth: 240,
      resizable: true,
      renderCell: AnonymousUserFormatter,
    },
    {
      key: 'platform',
      name: 'Platform',
      renderCell: ({ row }) => (row.platform ? row.platform : '-'),
    },
    {
      key: 'country',
      name: 'Country',
      renderCell: ({ row }) =>
        row.country ? <CountryFormatter value={row.country} editable={false} /> : 'N/A',
    },
  ];

  const allLevelColumns = useMemo(() => {
    return Object.keys(TrafficLevelColumn).map((key) => ({
      ...TrafficLevelColumn[key],
      resizable: true,
      minWidth: 200,
      sortable: true,
    }));
  }, []);

  return (
    <NinjaTable
      title='Events'
      date_key='trafficReportingEvents'
      cardProps={{ disable: true }}
      dataProvider='trafficReportingEvents'
      columns={[...allLevelColumns, ...columns]}
      disableFooter
      queryParams={{
        filters: {
          ...filter,
        },
      }}
    />
  );
};

export default TrafficReportingEvents;
